<template>
<div class="mt-1">

    <spinner v-bind:spinner='spinner'></spinner>
    <div v-if="items.length > 0 ">
    <h4><strong>PRODOTTO IN PROMO</strong></h4>
    <li v-for="item in items">
      {{ item.description}} dal {{ item.date1 }} al {{ item.date2 }}  [ <span style="color:blueviolet"> {{ item.discount }}% </span> ] 
    </li>
   
    </div>

</div>



</template>

<script>

import { mapGetters }     from 'vuex';
import api                from "@/api"
import alertBox           from '@/components/common/AlertBox.vue';
import spinner            from '@/components/common/Spinner.vue';


export default {
   props : ['productId'],
   components: {alertBox,spinner},  
  

  data () {
    return {      

      msg             : {
        title : ''
      },
      alert           : false,
      spinner         : false,
      items           : []
      

    }
  },
  computed: 
  {  
      ...mapGetters(['company']),
  },

  
  mounted()
    {
        this.getData()
    },
  created()
  {
       
  },
  methods: 
  {
    async getData()
    {
    
    this.spinner  = true
        
    const data      = {'productId' : this.productId}
    const sp        = {'sp' : 'spPromoProduct'}
    const json      = Object.assign(data, sp)
    await api.post(json).then(res => {
          
          if(res.status==200)
            {
              
            this.items = res.data.recordsets[0]
              
  
            }
           else if(res.status==500)
           {
                
                
                this.msg.title = 'ATTENZIONE '
                this.msg.body = res.data
                this.msg.type  = 1
                
                    
           } 
           else
            {
                
                
                this.msg.title = 'ATTENZIONE '  
                this.msg.body = res
                this.msg.type  = 1
                              
                 
            } 
          

          }).catch(err => {
              
              
              
              this.msg.title = 'ATTENZIONE '
              this.msg.body = err.message
              this.msg.type  = 1
                
              
          }).finally(() => {
            this.spinner = false
        });
  
    
    },

    
  
  }
  
   
  
}

</script>

<style scoped>
h4 {
  font-family: 'Roboto Condensed';
  font-size: 16px;
}  
      
span 
{
  font-family  : 'Roboto Condensed';
  font-size    : 18px;
  font-weight: bolder;
}
</style>